import React, { Component } from 'react';
import './index.css';
import { Switch, Route, withRouter } from 'react-router-dom';
import Login from './Components/Auth/Login';
import PrivateRoute from './Components/PrivateRoute';

import Page from './Page';
import Home from './Components/Home/Home';
import QueryList from './Components/Queries/QueryList';
import AlternateQuery from './Components/Queries/QueryCardHelpers/AlternateQuery';
import Feedback from './Components/Feedback/Feedback';
import Preferences from './Common/Preferences';
import ChatComponent from './Components/Queries/Chat/ChatComponent';
import NewChat from './Components/Queries/Chat/NewChat';
import PolicySelection from './Components/Home/PolicySelection';
import ChatList from './Components/Queries/Chat/ChatList';
import CurrentChat from './Components/Queries/Chat/CurrentChat';
import { getPageLoadingDom } from './utils';
import { inject, observer } from 'mobx-react';
import CustomSnackbar from './Common/CustomSnackbar';

@inject('userStore', 'commonStore')
@observer
class App extends Component {

  componentWillMount() {
    if (!this.props.userStore.token) {
      this.props.commonStore.setAppLoaded();
    }
  }

  componentDidMount() {
    if (this.props.userStore.token) {
      this.props.commonStore.setAppLoaded();
    }
  }


  render() {

    return (<div className="main-container">
      <Switch>
        <Route path="/login"
          render={props => (
            <Page {...props} headerText="Login" headerType="login" component={Login} />
          )} />
        <PrivateRoute path="/queries/details/:id"
          render={props => (
            <Page {...props} component={AlternateQuery} headerType="query" exact headerText="Your queries" />
          )} />
        <PrivateRoute path="/queries/pending/:id"
          render={props => (
            <Page {...props} component={AlternateQuery} headerType="query" exact headerText="Update your query" />
          )} />
        <PrivateRoute path="/queries/pending"
          render={props => (
            <Page {...props} headerText="Pending Queries" component={QueryList} headerType="query" exact />
          )} />
        <PrivateRoute path="/queries/completed"
          render={props => (
            <Page {...props} headerText="Completed Queries" component={QueryList} headerType="query" exact />
          )} />
        <PrivateRoute path="/preferences"
          render={props => (
            <Page {...props} component={Preferences} headerText="Preferences" headerType="preferences" exact />
          )} />
        <PrivateRoute path="/feedback"
          render={props => (
            <Page {...props} component={Feedback} headerText="How was your experience?" headerType="feedback" exact />
          )} />
        <PrivateRoute path="/policies"
          render={props => (
            <Page {...props} component={PolicySelection} headerText="Select your policy" headerType="policy" exact />
          )} />
        <Route path="/chat"
          render={props => (
            <Page {...props} component={NewChat} headerText="Chat" headerType="chat" exact />
          )} />
        <PrivateRoute path="/chats/:id"
          render={props => (
            <Page {...props} component={CurrentChat} headerText="Chat" headerType="chat" exact />
          )} />
        <PrivateRoute path="/chats"
          render={props => (
            <Page {...props} component={ChatList} headerText="Chats" headerType="chat" exact />
          )} />
        <Route path="/"
          render={props => (
            <Page {...props} component={Home} headerType="home" exact />
          )} />

      </Switch>
      <CustomSnackbar />
    </div>
    )
  }
}

export default withRouter(App);
